import {combineReducers} from 'redux';

import ingestReport from '@pluto/ingest-validation-report/Redux/IngestReportReducer';
import {qcReportsStatuses} from '@pluto/qc-reports-statuses';
import {timespanCategories} from '@pluto/timespan-categories';
import qcToolsMetadata from '../../QCTools/QCToolsMetadata/Redux/QCToolsMetadataReducer';
import qcToolsArtwork from '../../QCTools/QCToolsArtwork/Redux/QCToolsArtworkReducer';
import publishingRights from '../../QCTools/QCToolsPublishingRights/Redux/QCToolsPublishingRightsReducer';
import statusIndicators, {jobDeliveryStatus} from '../../QCTools/Redux/QCToolsReducer';

const qcToolsStore = combineReducers({
    qcToolsArtwork,
    qcToolsMetadata,
    ingestReport,
    qcReportsStatuses,
    publishingRights,
    statusIndicators,
    timespanCategories,
    jobDeliveryStatus,
});

export default qcToolsStore;
